import { render, staticRenderFns } from "./AlertForApp.vue?vue&type=template&id=4da2d8ac&scoped=true&"
import script from "./AlertForApp.vue?vue&type=script&lang=js&"
export * from "./AlertForApp.vue?vue&type=script&lang=js&"
import style0 from "./AlertForApp.vue?vue&type=style&index=0&id=4da2d8ac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4da2d8ac",
  null
  
)

export default component.exports